// extracted by mini-css-extract-plugin
export default {"parent":"paymentConfirmation_parent__aL+ci"};